import Facade from '@/Facade'

export class ReelsContainerHelper {
    public static calculateContainerWidth(): number {
        return this.calculateReelWidth() * Facade.reelsConfig.TOTAL_REELS
    }

    public static calculateReelWidth(): number {
        return Facade.symbolsConfig.WIDTH + Facade.reelsConfig.REELS_GAP
    }

    public static calculateContainerHeight(): number {
        return this.calculateReelHeight() * Facade.reelsConfig.VISIBLE_SYMBOLS_PER_REEL
    }

    public static calculateReelHeight(): number {
        return Facade.symbolsConfig.HEIGHT + Facade.reelsConfig.SYMBOLS_GAP
    }
}
